import React, { useEffect, useState } from "react";
import {
  filterData,
  CourseInfoFilterProps,
} from "../../../Data/courseFilterData";

export default function CourseInfoFilter(props: CourseInfoFilterProps) {
  const {
    selectedFieldOfStudy,
    setSelectedFieldOfStudy,
    selectedMajor,
    setSelectedMajor,
    selectedLevel,
    setSelectedLevel,
    fieldOfStudyOptions,
    majorOptions,
    levelOptions,
  } = props;
  return (
    <form
      action=""
      className="grid grid-cols-1 lg:grid-cols-3 gap-2 md:gap-4 text-sm mx-6 lg:mx-0 lg:w-3/4"
    >
      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2">
        <label htmlFor="fieldOfStudy">
          {filterData.courseInfo.fieldOfStudy.label}
        </label>
        <select
          name="fieldOfStudy"
          id="fieldOfStudy"
          value={selectedFieldOfStudy}
          onChange={(e) => {
            setSelectedFieldOfStudy(e.target.value);
            setSelectedMajor(""); // Reset major when field of study changes
          }}
        >
          {fieldOfStudyOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* major  */}
      <div
        className={`flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2 ${
          !selectedFieldOfStudy ? "bg-gray-200 cursor-not-allowed" : ""
        }`}
      >
        <label htmlFor="major">{filterData.courseInfo.major.label}</label>
        <select
          name="major"
          id="major"
          value={selectedMajor}
          onChange={(e) => setSelectedMajor(e.target.value)}
          disabled={!selectedFieldOfStudy}
          className="disabled:cursor-not-allowed"
        >
          {majorOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* level  */}
      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2">
        <label htmlFor="level">{filterData.courseInfo.level.label}</label>
        <select
          name="level"
          id="level"
          value={selectedLevel}
          onChange={(e) => setSelectedLevel(e.target.value)}
        >
          {levelOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </form>
  );
}
